import { atom } from "jotai";

export const convocatoriasAtom = atom ([]);
export const loadingAtom = atom(false);